import { Button } from '@casumo/dojo-react';
import { memo } from 'react';
import { TEST_ID } from '../../utils/constants';

type TDepositLimitsButton = {
  disabled?: boolean;
  label?: string;
  gtmPayload?: Record<string, string>;
  handleNext: ({ gtmPayload, redirectTo }: { gtmPayload?: Record<string, string>; redirectTo?: string }) => void;
}

const DepositLimitsButton = ({ label, disabled = false, gtmPayload, handleNext }: TDepositLimitsButton) => (
  <Button variant="tertiary" disabled={disabled} className="disabled:text-grey-20"
    onClick={() => handleNext?.({ gtmPayload, redirectTo: '1' })}
    data-testid={TEST_ID.BUTTON_SECONDARY}
  >
    {label}
  </Button>
);

const Memoized = memo(DepositLimitsButton);
Memoized.displayName = 'DepositLimitsButton';

export default Memoized;
